import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import { determineLink } from "../assets/data";

const Determine = () => {
	return (
		<section className="determine__container">
			<div className="container determine">
				<h4>
					Let's determine it
					<div className="headline"></div>
				</h4>
				<div className="determine__container-values">
					{determineLink.map(({ id, path, text }) => {
						return (
							<Link className="determine__container-value" to={path} key={id}>
								<span>{id}</span>
								<p>{text}</p>
								<BsArrowRight className="arrow__icon" />
							</Link>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default Determine;
